import { ISiteLoginParams } from '../types/ISiteLoginParams';
import { IGetSessionInfoResult } from './GetSessionInfoRequest';
import { Request } from './Request';

export class KerberosLoginRequest extends Request<ISiteLoginParams, IGetSessionInfoResult> {
  constructor(params: ISiteLoginParams) {
    super('auth/kerberosLogin', params);
  }
}
